import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CompanionResearch from './CompanionResearch';

interface CompanionResearchModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CompanionResearchModal: React.FC<CompanionResearchModalProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence key="companion-research-modal">
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-2 sm:p-4 modal-container"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            className="bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 rounded-2xl shadow-[0_0_50px_rgba(147,51,234,0.3)] border border-purple-500/30 w-full max-w-7xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden modal-content backdrop-blur-sm"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Animated Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 via-transparent to-blue-600/20 animate-pulse"></div>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(147,51,234,0.1),transparent_50%)]"></div>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(59,130,246,0.1),transparent_50%)]"></div>
            
            {/* Header */}
            <div className="relative sticky top-0 bg-gradient-to-r from-purple-600/90 via-blue-600/90 to-purple-600/90 backdrop-blur-md text-white p-4 sm:p-6 flex justify-between items-center rounded-t-2xl z-10 border-b border-purple-400/30">
              <div className="flex items-center gap-3">
                <div className="relative">
                  <div className="text-3xl sm:text-4xl animate-pulse">🧬</div>
                  <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full animate-ping"></div>
                </div>
                <div>
                  <h1 className="text-xl sm:text-3xl font-bold bg-gradient-to-r from-white to-purple-200 bg-clip-text text-transparent">
                    Begleiter-Forschung
                  </h1>
                  <p className="text-xs sm:text-sm text-purple-200 opacity-80">
                    Globale Boni für alle Begleiter
                  </p>
                </div>
              </div>
              <button
                onClick={onClose}
                className="text-white hover:text-gray-200 transition-colors duration-200 text-xl sm:text-2xl p-2 touch-manipulation min-h-[44px] min-w-[44px] flex items-center justify-center rounded-lg hover:bg-white/10"
              >
                ✕
              </button>
            </div>

            {/* Content */}
            <div className="relative overflow-y-auto max-h-[calc(95vh-100px)] sm:max-h-[calc(90vh-100px)] p-4 sm:p-6">
              <CompanionResearch />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CompanionResearchModal; 